import React from "react";

export default () => (
    <React.Fragment>
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(
                    {
                        "@context": "http://schema.org",
                        "@type": "HotelRoom",
                        "name": "Deluxe Rooms",
                        "url": "https://www.hoteltwintowers.com/hotel-room-in-shimla/deluxe-room",
                        "image": "https://www.hoteltwintowers.com/images/deluxe-banner.png",
                        "description": "These spacious rooms (380 square feet) are equipped with all the latest conveniences and amenities for a relaxing and luxurious stay. These are one of the best deluxe rooms in Kufri. There is high-speed Internet access (Wi-Fi), an LED TV, an electric kettle, an ironing board, a wardrobe, a daily cleaning service, a hair dryer, and more in each room.",
                        "containedInPlace": {
                            "@type": "Place",
                            "name": "The Twin Towers Hotel",
                            "url": "https://hoteltwintowers.com/",
                            "hasMap": "https://goo.gl/maps/GzserDhdgJJFburx5",
                            "address": {
                                "@type": "PostalAddress",
                                "streetAddress": "NH 05, New kufri, Galu, Hills,",
                                "addressLocality": "Shimla",
                                "addressRegion": "Indian Himalayan Region",
                                "postalCode": "171209",
                                "addressCountry": "India"
                            }
                        },
                        "bed": {
                            "@type": "BedDetails",
                            "numberOfBeds": 2
                        },
                        "occupancy": {
                            "@type": "QuantitativeValue",
                            "maxValue": "2"
                        },
                        "amenityFeature": [
                            {
                                "@type": "LocationFeatureSpecification", "value": "True", "name": "City Views"
                            },
                            { "@type": "LocationFeatureSpecification", "value": "True", "name": "Balcony" },
                            { "@type": "LocationFeatureSpecification", "value": "True", "name": "King Size Bed" }
                        ]
                    }
                )
            }}
        />
    </React.Fragment>
);
